import React from 'react'
import Button from '@sharedComponents/Button'
import {ButtonType} from '@sharedComponents/Button/types'
import {useTranslation} from 'react-i18next'
import {CancelModalContentProps} from './types'
import './Scss/edit-pdf-cancel-modal.scss';

const CancelModalContent = (props: CancelModalContentProps) => {
  const {t} = useTranslation();

  return (
    <div className={'edit-pdf-cancel-modal'}>
      <h3>{t('modal.areyousure')}</h3>
      <p>{t('message.savewarning')}</p>
      <div className={'edit-pdf-cancel-modal__button'}>
        <Button
          type={ButtonType.PRIMARY}
          text={t('button.nostay')}
          onClick={props.onHideCancelModal}
          large={true}
          className="cancel-modal-button"
        />
      </div>
      <div className={'edit-pdf-cancel-modal__button'}>
        <Button
          type={ButtonType.SECONDARY}
          text={t('button.yescancel')}
          onClick={props.onConfirmCancel}
          large={true}
          className="cancel-modal-button"
        />
      </div>
    </div>
  )
}

export default CancelModalContent
